// src/pages/ForgotPasswordPage.js
// Accessible at /forgot-password?type=vendor  or  /forgot-password?type=malladmin

import React, { useState } from 'react';
import api from '../services/api';

export default function ForgotPasswordPage() {
  const params   = new URLSearchParams(window.location.search);
  const type     = params.get('type') || 'vendor';
  const isMall   = type === 'malladmin';

  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const endpoint = isMall ? '/mall/forgot-password' : '/auth/forgot-password';
  const label    = isMall ? 'Mall Admin' : 'Vendor';

  const handle = async () => {
    if (!email) return setError('Please enter your email.');
    setLoading(true); setError('');
    try {
      await api.post(endpoint, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:40, width:400 }}>

        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🔑</div>
          <div style={{ fontSize:20, fontWeight:700, color:'var(--accent)' }}>Forgot Password</div>
          <div style={{ fontSize:13, color:'var(--text2)', marginTop:4 }}>{label} account</div>
        </div>

        {sent ? (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:40, marginBottom:16 }}>📬</div>
            <div style={{ fontWeight:700, marginBottom:8 }}>Check your inbox</div>
            <div style={{ fontSize:13, color:'var(--text2)', marginBottom:24 }}>
              If <strong>{email}</strong> is registered, a reset link has been sent. It expires in 1 hour.
            </div>
            <button className="btn btn-ghost btn-sm" onClick={() => window.location.href = '/'}> ← Back to Login</button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom:20 }}>
              <div className="section-label" style={{ marginBottom:6 }}>Email address</div>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                onKeyDown={e => e.key === 'Enter' && handle()}
                autoFocus
              />
            </div>

            {error && (
              <div style={{ color:'var(--red)', fontSize:13, marginBottom:14, textAlign:'center' }}>{error}</div>
            )}

            <button className="btn btn-primary" style={{ width:'100%', padding:13 }} onClick={handle} disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div style={{ marginTop:16, textAlign:'center' }}>
              <button className="btn btn-ghost btn-sm" onClick={() => window.location.href = '/'}>
                ← Back to Login
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
